module.exports = __webpack_public_path__ + "img/tango-7b1662ce-6cfe-4216-ddf7-08d959eef549.png";